import { UserPreferences } from './user-preferences.model';

export interface UserPreferencesState {
  /** In-memory copy of the backend blob, kept as the single source of truth. */
  preferences: UserPreferences;
  /**
   * Whether an initial load has actually succeeded. Persistence is gated on
   * this flag so that a failed `GET` (treated as empty) can never lead to
   * overwriting the backend with a near-empty blob.
   */
  loaded: boolean;
  /** The initial load failed: `preferences` holds the defaults, and stays so. */
  loadFailed: boolean;
  /** Last persistence error message, surfaced to the UI; `null` when healthy. */
  persistError: string | null;
}

export const initialUserPreferencesState: UserPreferencesState = {
  preferences: {},
  loaded: false,
  loadFailed: false,
  persistError: null
};
